import React from 'react';

const createContext = () => React.createContext({});
const BaseContext = React.createContext();
export { createContext, BaseContext };
